<template>
  <div :class="{ 'mb-1': small }">
    <v-tooltip bottom content-class="custom-bottom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          v-if="status !== null && status !== undefined"
          class="mx-2 custom-status font-weight-600 d-inline-table text-uppercase justify-center font-10 status-chip-enhanced"
          :color="param?.color || 'grey'"
          :text-color="getTextColor(param?.textcolor, param?.color)"
          label
          :small="small"
          :class="{ 'd-inline': small, customerInvoice }"
        >
          <template v-if="param?.value == 'submit_for_approval'">
            <template v-if="userDetails.role == 4">
              Submied For Approval
            </template>
            <template v-else> Pending For Approval</template>
          </template>
          <template v-else>{{
            param?.text ||
            (status !== null && status !== undefined ? String(status) : "")
          }}</template>
        </v-chip>
      </template>
      <span>Status</span>
    </v-tooltip>
  </div>
</template>

<script>
import { GET } from "@/core/services/store/request.module";
import LocalService from "@/core/services/local.service";
import JwtService from "@/core/services/jwt.service";

export default {
  data: () => {
    return {
      pageLoading: true,
      userDetails: {},
      statusList: {},
      param: {
        color: "grey",
        textcolor: null,
        text: null,
      },
    };
  },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Number,
      default: 0,
    },
    endpoint: {
      type: String,
      required: true,
      default: "",
    },
    customerInvoice: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    status: {
      deep: true,
      handler() {
        this.assignStatusList();
      },
    },
  },
  methods: {
    getTextColor(textcolor, bgColor) {
      // If textcolor is explicitly provided, use it
      if (textcolor) {
        return textcolor;
      }

      // Default light colors that need dark text
      const lightColors = [
        "white",
        "lighten-5",
        "lighten-4",
        "lighten-3",
        "lighten-2",
        "lighten-1",
        "yellow",
        "amber",
        "lime",
        "orange light",
        "grey lighten-4",
        "grey lighten-3",
      ];

      // Check if background is light
      if (
        bgColor &&
        lightColors.some((color) =>
          bgColor.toLowerCase().includes(color.toLowerCase())
        )
      ) {
        return "#333333"; // Dark grey text for light backgrounds
      }

      // Default to white text for dark backgrounds
      return "white";
    },
    get_status_list() {
      const _this = this;
      return new Promise((resolve, reject) => {
        if (_this.endpoint) {
          let cache_response = LocalService.getData(_this.endpoint);
          if (_this.lodash.isEmpty(cache_response) === false) {
            resolve(cache_response);
          } else {
            _this.$store
              .dispatch(GET, { url: _this.endpoint })
              .then((response) => {
                resolve(response.data);
                LocalService.saveData(_this.endpoint, response.data);
              })
              .catch((error) => {
                reject(error);
              });
          }
        } else {
          resolve([]);
        }
      });
    },
    assignStatusList() {
      const _this = this;
      _this.pageLoading = true;
      _this
        .get_status_list()
        .then((response) => {
          if (_this.lodash.isEmpty(response) === false) {
            _this
              .setParams(response)
              .then((statusList) => {
                // try numeric key first, then value or text
                let key = _this.status;
                let item = statusList[key];
                if (!item && key !== null && key !== undefined) {
                  // convert to string in case response values are strings
                  key = String(key);
                  item = statusList[key];
                }
                _this.param = item || {
                  color: "grey",
                  textcolor: "white",
                  text: String(_this.status),
                };
              })
              .finally(() => {
                _this.pageLoading = false;
              });
          } else {
            // empty list – still stop loading and show fallback text
            _this.param = {
              color: "grey",
              textcolor: "white",
              text: String(_this.status),
            };
            _this.pageLoading = false;
          }
        })
        .catch(() => {
          // on error, hide loader to avoid blank rows
          _this.pageLoading = false;
        });
    },
    setParams(response) {
      const _this = this;
      return new Promise((resolve) => {
        for (let i = response.length - 1; i >= 0; i--) {
          const itm = response[i];
          // map by numeric status key
          _this.statusList[itm.status] = itm;
          // also map by value (string) if present
          if (itm.value !== undefined && itm.value !== null) {
            _this.statusList[String(itm.value)] = itm;
          }
          // and by text for safety
          if (itm.text !== undefined && itm.text !== null) {
            _this.statusList[String(itm.text)] = itm;
          }
          if (i === 0) {
            resolve(_this.statusList);
          }
        }
      });
    },
  },
  beforeDestroy() {
    this.param = { color: "grey", textcolor: null, text: null };
  },
  mounted() {
    this.assignStatusList();
    this.userDetails = JwtService.currentUser();
  },
};
</script>

<style scoped>
.status-chip-enhanced {
  min-height: 28px !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
  padding: 0 12px !important;
  font-size: 11px !important;
  letter-spacing: 0.5px !important;
}

.custom-status {
  border: none !important;
}

.status-chip-enhanced ::v-deep .v-chip__content {
  padding: 0 !important;
}
</style>
